import { Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import CustomPopover from "components/Atoms/CustomPopover"
import Error from "components/Common/Error"
import TablePagination from "components/Molecules/TablePagination"
import NewResourceButton from "components/Organisms/AddResourceButton"
import OverFlowMenu from "components/Organisms/OverFlowMenu"
import SerialColumn from "components/Organisms/table/SerialColumn"
import CustomReactTable from "components/Templates/CustomReactTable"
import DetailLink from "components/Templates/DetailLink"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import { useSellableItemList } from "graphql/sellable-item/sellable-item.hooks"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import DepartmentVarietyList from "../department/DepartmentVarietyList"
import SellableItemFilter from "./SellableItemFilter"
import CustomCard from "components/Atoms/CustomCard"

const COLUMNS = [
  SerialColumn,
  {
    value: "id",
    Header: "",
    width: 55,
    Cell({ original }) {
      const navigate = useNavigate()
      return (
        <CustomPopover
          position={Position.BOTTOM_LEFT}
          minimal={true}
          content={
            <Menu>
              <MenuItem
                text="Sellable Item"
                icon="edit"
                onClick={e =>
                  navigate(`/d/registration/sellable-items/${original?.id}`)
                }
              />
            </Menu>
          }
        >
          <CustomButton
            style={{ transform: "rotate(90deg)" }}
            icon="more"
            minimal={true}
          />
        </CustomPopover>
      )
    },
  },
  {
    width: 330,
    Header: "Name",
    accessor: "name",
    Cell({ original }) {
      const [isOpen, setOpen] = useState(false)
      const photo = original?.primaryPhoto
      return (
        <span>
          {photo?.url && (
            <img
              onClick={e => setOpen(true)}
              className="mr-3 inline-block"
              style={{
                cursor: "pointer",
                borderRadius: 5,
              }}
              src={photo?.url}
              height="25"
              width="25"
              alt={original?.name}
            />
          )}
          <DetailLink id={original?.id}>{original?.name}</DetailLink>
          <CustomDialog
            light
            scrollable={false}
            isOpen={isOpen}
            onClose={e => setOpen(false)}
            icon="shopping-cart"
            title={original?.name}
          >
            <img
              onClick={e => setOpen(true)}
              className="mr-3"
              style={{
                cursor: "pointer",
                borderRadius: 5,
              }}
              src={photo?.url}
              alt={original?.name}
              height="100%"
              width="100%"
            />
          </CustomDialog>
        </span>
      )
    },
  },
  {
    width: 250,
    Header: "Description",
    accessor: "shortDescription",
    Cell({ value, original }) {
      return <span className="text-sm">{value}</span>
    },
  },
  {
    width: 80,
    Header: "Rating",
    accessor: "overallRating",
    Cell({ value }) {
      return value ?? "NA"
    },
  },
  {
    Header: "Groups",
    accessor: "itemGroups",
    Cell({ value }) {
      return <OverFlowMenu intent="primary" items={value} />
    },
  },
  {
    Header: "Crops",
    accessor: "sellableVarieties",
    Cell({ value }) {
      const varieties = value?.map(v => v.variety)
      return <DepartmentVarietyList varieties={varieties} />
    },
  },
]
const SellableItems = () => {
  const [{ search, page }, setFilter] = useSearchFilter()
  const { data, loading, error } = useSellableItemList()

  if (error) return <Error message={error?.name} />

  return (
    <CustomCard className="p-0">
      <ModuleHeader
        borderBottom="none"
        query={search ?? ""}
        filter={<SellableItemFilter />}
        onQueryChange={search => {
          setFilter(prev => ({
            ...prev,
            search,
            page: 0,
          }))
        }}
        white
        className="p-3"
        header={<Description icon="shopping-cart" title="Sellable Items" />}
      >
        <TablePagination
          className="mr-3"
          page={page}
          onPageChange={page => {
            setFilter(prev => ({
              ...prev,
              page,
            }))
          }}
        />

        <NewResourceButton module="sellable_item" />
      </ModuleHeader>
      <CustomReactTable
        leftAlign={true}
        loading={loading}
        loadingText="Loading Sellable Items"
        pageSize={13}
        data={data?.allSellableItems}
        columns={COLUMNS}
      />
    </CustomCard>
  )
}

export default SellableItems
